(function () {
  'use strict';

  var STORAGE_KEY = 'wsnzKingdomAssessment';
  var VERSION = 2;
  var KINGDOM_IDS = ['ariki','takutai','mokua','aria','ranui','nepiha','waimahana','koru','kopu','hirotapu','ataahua','raweka'];
  var KINGDOM_NAMES = { ariki:'Ariki', takutai:'Takutai', mokua:'Mokua', aria:'Aria', ranui:'Ranui', nepiha:'Nepiha', waimahana:'Waimahana', koru:'Koru', kopu:'Kopu', hirotapu:'Hirotapu', ataahua:'Ataahua', raweka:'Raweka' };

  var TIE_BREAKERS = {
    ariki: 'My responsibility to those who depend on me.',
    takutai: 'My freedom to choose my own path.',
    mokua: 'My command over my own actions and emotions.',
    aria: 'My freedom to feel and express what is true.',
    ranui: 'My determination to question and uncover the truth.',
    nepiha: 'My loyalty to the people I love.',
    waimahana: 'My connection with nature and the balance of life.',
    koru: 'My ability to create value from what is available.',
    kopu: 'My drive to grow and fulfil my potential.',
    hirotapu: 'My search for meaning and deeper understanding.',
    ataahua: 'My ability to bring clarity and order to uncertainty.',
    raweka: 'My strength to adapt and endure whatever comes.'
  };
  var QUESTIONS = [
    { prompt: 'A difficult task needs doing, but nobody volunteers.', answers: [
      { text: 'Step forward and take responsibility.', kingdom: 'ariki' },
      { text: 'Let people choose for themselves.', kingdom: 'takutai' }
    ]},
    { prompt: 'Which concerns you more?', answers: [
      { text: 'People avoiding responsibility.', kingdom: 'ariki' },
      { text: 'People losing their freedom.', kingdom: 'takutai' }
    ]},
    { prompt: 'A leader gives you an order you disagree with.', answers: [
      { text: 'Follow it for the good of the group.', kingdom: 'ariki' },
      { text: 'Follow your own judgment.', kingdom: 'takutai' }
    ]},
    { prompt: 'Which statement feels more true?', answers: [
      { text: 'Someone must carry the burden.', kingdom: 'ariki' },
      { text: 'No one should carry chains.', kingdom: 'takutai' }
    ]},
    { prompt: 'When emotions become overwhelming:', answers: [
      { text: 'Control them.', kingdom: 'mokua' },
      { text: 'Express them.', kingdom: 'aria' }
    ]},
    { prompt: 'What matters more?', answers: [
      { text: 'Self-mastery.', kingdom: 'mokua' },
      { text: 'Emotional authenticity.', kingdom: 'aria' }
    ]},
    { prompt: 'A friend is grieving.', answers: [
      { text: 'Help them regain stability.', kingdom: 'mokua' },
      { text: 'Sit with them in the emotion.', kingdom: 'aria' }
    ]},
    { prompt: 'Which weakness worries you more?', answers: [
      { text: 'Losing control.', kingdom: 'mokua' },
      { text: 'Losing connection.', kingdom: 'aria' }
    ]},
    { prompt: 'Meeting someone new:', answers: [
      { text: 'Trust must be earned.', kingdom: 'ranui' },
      { text: 'Trust should be offered first.', kingdom: 'nepiha' }
    ]},
    { prompt: 'Which is more dangerous?', answers: [
      { text: 'Being deceived.', kingdom: 'ranui' },
      { text: 'Being alone.', kingdom: 'nepiha' }
    ]},
    { prompt: 'A close friend makes an unbelievable claim.', answers: [
      { text: 'Question it carefully.', kingdom: 'ranui' },
      { text: 'Give them the benefit of the doubt.', kingdom: 'nepiha' }
    ]},
    { prompt: 'What creates stronger relationships?', answers: [
      { text: 'Honesty.', kingdom: 'ranui' },
      { text: 'Loyalty.', kingdom: 'nepiha' }
    ]},
    { prompt: 'You discover a valuable natural resource.', answers: [
      { text: 'Protect it.', kingdom: 'waimahana' },
      { text: 'Develop it.', kingdom: 'koru' }
    ]},
    { prompt: 'Which statement feels more true?', answers: [
      { text: 'Not everything should be used.', kingdom: 'waimahana' },
      { text: 'Potential should never be wasted.', kingdom: 'koru' }
    ]},
    { prompt: 'Success means:', answers: [
      { text: 'Living in balance.', kingdom: 'waimahana' },
      { text: 'Creating value.', kingdom: 'koru' }
    ]},
    { prompt: 'Which worries you more?', answers: [
      { text: 'Losing connection with nature.', kingdom: 'waimahana' },
      { text: 'Missing opportunities.', kingdom: 'koru' }
    ]},
    { prompt: 'When you look at your life:', answers: [
      { text: 'I focus on who I could become.', kingdom: 'kopu' },
      { text: 'I focus on understanding who I am.', kingdom: 'hirotapu' }
    ]},
    { prompt: 'Which is more important?', answers: [
      { text: 'Improvement.', kingdom: 'kopu' },
      { text: 'Wisdom.', kingdom: 'hirotapu' }
    ]},
    { prompt: 'What motivates you more?', answers: [
      { text: 'Future potential.', kingdom: 'kopu' },
      { text: 'Present meaning.', kingdom: 'hirotapu' }
    ]},
    { prompt: 'Which fear is stronger?', answers: [
      { text: 'Stagnation.', kingdom: 'kopu' },
      { text: 'Living without purpose.', kingdom: 'hirotapu' }
    ]},
    { prompt: 'A plan begins falling apart.', answers: [
      { text: 'Restore structure.', kingdom: 'ataahua' },
      { text: 'Adapt immediately.', kingdom: 'raweka' }
    ]},
    { prompt: 'Which creates strength?', answers: [
      { text: 'Preparation.', kingdom: 'ataahua' },
      { text: 'Resilience.', kingdom: 'raweka' }
    ]},
    { prompt: 'What frustrates you more?', answers: [
      { text: 'Disorder.', kingdom: 'ataahua' },
      { text: 'Rigidity.', kingdom: 'raweka' }
    ]},
    { prompt: 'Which statement feels more true?', answers: [
      { text: 'The best outcome can be designed.', kingdom: 'ataahua' },
      { text: 'The best outcome emerges through challenge.', kingdom: 'raweka' }
    ]}
  ];

  function getKingdoms() {
    var source = window.WSNZ_KINGDOMS || {};
    var raw = source.kingdoms != null ? source.kingdoms : source;
    var normalized = {};

    if (Array.isArray(raw)) {
      raw.forEach(function (kingdom) {
        if (kingdom && kingdom.id) normalized[String(kingdom.id).toLowerCase()] = kingdom;
      });
    } else if (raw && typeof raw === 'object') {
      KINGDOM_IDS.forEach(function (id) {
        if (raw[id] && typeof raw[id] === 'object') normalized[id] = raw[id];
      });
    }

    KINGDOM_IDS.forEach(function (id) {
      if (!normalized[id]) normalized[id] = { id: id, name: KINGDOM_NAMES[id] };
    });

    return normalized;
  }

  function createScores() {
    var scores = {};
    KINGDOM_IDS.forEach(function (id) { scores[id] = 0; });
    return scores;
  }

  function safeParse(value) {
    try { return JSON.parse(value); } catch (error) { return null; }
  }

  function saveResult(result) {
    try { localStorage.setItem(STORAGE_KEY, JSON.stringify(result)); } catch (error) {}
    try {
      var memory = safeParse(localStorage.getItem('wsnzExplorerMemory')) || {};
      memory.assessment = result;
      memory.assignedKingdom = result.kingdom;
      localStorage.setItem('wsnzExplorerMemory', JSON.stringify(memory));
    } catch (error) {}
    document.dispatchEvent(new CustomEvent('wsnz:assessment-complete', { detail: result }));
  }

  function getResult() {
    try { return safeParse(localStorage.getItem(STORAGE_KEY)); } catch (error) { return null; }
  }

  function reset() {
    try { localStorage.removeItem(STORAGE_KEY); } catch (error) {}
  }

  window.WSNZ = window.WSNZ || {};
  window.WSNZ.assessment = {
    version: VERSION,
    storageKey: STORAGE_KEY,
    questions: QUESTIONS.slice(),
    getResult: getResult,
    hasCompleted: function () { return Boolean(getResult() && getResult().kingdom); },
    reset: reset
  };

  function init(root) {
    if (!root || root.dataset.wsnzAssessmentReady === 'true') return;
    root.dataset.wsnzAssessmentReady = 'true';

    var kingdoms = getKingdoms();
    var state = {
      index: 0,
      answers: [],
      scores: createScores(),
      tied: [],
      finalKingdom: null,
      tieBreakerUsed: false
    };

    var screens = {
      intro: root.querySelector('[data-screen="intro"]'),
      question: root.querySelector('[data-screen="question"]'),
      tiebreaker: root.querySelector('[data-screen="tiebreaker"]'),
      result: root.querySelector('[data-screen="result"]')
    };
    var progress = root.querySelector('[data-assessment-progress]');
    var progressText = root.querySelector('[data-assessment-progress-text]');
    var questionNumber = root.querySelector('[data-question-number]');
    var questionPrompt = root.querySelector('[data-question-prompt]');
    var answersWrap = root.querySelector('[data-question-answers]');
    var backButton = root.querySelector('[data-action="back"]');

    function play(name) {
      if (window.WSNZ.audio && typeof window.WSNZ.audio.play === 'function') {
        window.WSNZ.audio.play(name);
      }
    }

    function show(name) {
      Object.keys(screens).forEach(function (key) {
        var active = key === name;
        screens[key].hidden = !active;
        screens[key].setAttribute('aria-hidden', active ? 'false' : 'true');
      });
      root.dataset.currentScreen = name;
      window.scrollTo({ top: Math.max(0, root.getBoundingClientRect().top + window.scrollY - 24), behavior: 'smooth' });
    }

    function updateProgress() {
      var complete = Math.min(state.index, QUESTIONS.length);
      var percent = Math.round((complete / QUESTIONS.length) * 100);
      progress.style.width = percent + '%';
      progressText.textContent = complete + ' of ' + QUESTIONS.length;
      root.style.setProperty('--wsnz-assessment-progress', percent + '%');
    }

    function renderQuestion() {
      var question = QUESTIONS[state.index];
      questionNumber.textContent = 'Question ' + (state.index + 1);
      questionPrompt.textContent = question.prompt;
      answersWrap.innerHTML = '';
      question.answers.forEach(function (answer, answerIndex) {
        var button = document.createElement('button');
        button.type = 'button';
        button.className = 'wsnz-assessment__answer';
        button.innerHTML = '<span class="wsnz-assessment__answer-key">' + (answerIndex === 0 ? 'A' : 'B') + '</span><span>' + answer.text + '</span>';
        button.addEventListener('mouseenter', function () { play('hover'); }, { passive: true });
        button.addEventListener('click', function () { selectAnswer(answer.kingdom); });
        answersWrap.appendChild(button);
      });
      backButton.hidden = state.index === 0;
      updateProgress();
      show('question');
      setTimeout(function () {
        var first = answersWrap.querySelector('button');
        if (first) first.focus({ preventScroll: true });
      }, 80);
    }

    function selectAnswer(kingdomId) {
      play('button');
      state.answers[state.index] = kingdomId;
      state.index += 1;
      if (state.index < QUESTIONS.length) renderQuestion();
      else scoreAssessment();
    }

    function rebuildScores() {
      state.scores = createScores();
      state.answers.forEach(function (id) {
        if (Object.prototype.hasOwnProperty.call(state.scores, id)) state.scores[id] += 1;
      });
    }

    function scoreAssessment() {
      rebuildScores();
      var highest = Math.max.apply(null, Object.keys(state.scores).map(function (id) { return state.scores[id]; }));
      state.tied = KINGDOM_IDS.filter(function (id) { return state.scores[id] === highest; });
      if (state.tied.length === 1) finish(state.tied[0], false);
      else renderTieBreaker();
    }

    function renderTieBreaker() {
      state.tieBreakerUsed = true;
      var options = root.querySelector('[data-tiebreaker-options]');
      options.innerHTML = '';
      state.tied.forEach(function (id) {
        var kingdom = kingdoms[id] || { id: id, name: KINGDOM_NAMES[id] };
        var button = document.createElement('button');
        button.type = 'button';
        button.className = 'wsnz-assessment__principle';
        var tieBreaker = kingdom.tieBreaker || (kingdom.assessment && kingdom.assessment.tieBreaker) || TIE_BREAKERS[id] || kingdom.motto || kingdom.virtue || kingdom.name;
        button.innerHTML = '<span class="wsnz-assessment__principle-name">' + (kingdom.name || KINGDOM_NAMES[id]) + '</span><span>' + tieBreaker + '</span>';
        button.addEventListener('mouseenter', function () { play('hover'); }, { passive: true });
        button.addEventListener('click', function () {
          play('button');
          finish(id, true);
        });
        options.appendChild(button);
      });
      if (!options.children.length) {
        options.innerHTML = '<p class="wsnz-assessment__error">The tied kingdom options could not be loaded. Refresh the page and retake the assessment.</p>';
      }
      show('tiebreaker');
    }

    function assetUrl(filename) {
  if (!filename) return '';

  if (
    /^(?:https?:)?\/\//i.test(filename) ||
    filename.charAt(0) === '/'
  ) {
    return filename;
  }

  if (window.WSNZ_DATABASE_URL) {
    try {
      var url = new URL(
        window.WSNZ_DATABASE_URL,
        window.location.href
      );

      var parts = url.pathname.split('/');
      parts[parts.length - 1] =
        encodeURIComponent(filename);

      url.pathname = parts.join('/');
      url.search = '';

      return url.toString();
    } catch (error) {}
  }

  return filename;
}

    function finish(id, tieBreakerUsed) {
      var kingdom = kingdoms[id];
      if (!kingdom) return;
      state.finalKingdom = id;
      state.tieBreakerUsed = tieBreakerUsed;
      var result = {
        version: VERSION,
        kingdom: id,
        scores: state.scores,
        completedAt: new Date().toISOString(),
        tieBreakerUsed: Boolean(tieBreakerUsed)
      };
      saveResult(result);

      var resultContent =
  kingdom.content &&
  kingdom.content.assessmentResult;

var visitorContent =
  kingdom.content &&
  kingdom.content.visitorView;

root.querySelector('[data-result-name]').textContent =
  kingdom.name || KINGDOM_NAMES[id] || id;

root.querySelector('[data-result-title]').textContent =
  kingdom.title || kingdom.virtue || '';

root.querySelector('[data-result-interpretation]').textContent =
  kingdom.assessmentInterpretation ||
  (kingdom.assessmentResult &&
    kingdom.assessmentResult.interpretation) ||
  (resultContent &&
    resultContent.interpretation) ||
  kingdom.visitorDescription ||
  (visitorContent &&
    visitorContent.heroIntroduction) ||
  '';

var mottoText = kingdom.motto || '';

root.querySelector('[data-result-motto]').textContent =
  mottoText ? '“' + mottoText + '”' : '';

var kingdomUrl = '/pages/' + id;
      root.querySelector('[data-result-route]').href = kingdomUrl;
      root.querySelector('[data-result-continue]').href = kingdomUrl;
      var crest = root.querySelector('[data-result-crest]');
      crest.alt = kingdom.name + ' kingdom crest';
      var crestFile =
  kingdom.crest ||
  (kingdom.assets && kingdom.assets.crest) ||
  (kingdom.media && kingdom.media.crest) ||
  (id + '-crest.webp');
      crest.src = assetUrl(crestFile);
      var backgroundFile = kingdom.background || kingdom.banner || (kingdom.assets && (kingdom.assets.background || kingdom.assets.banner)) || (id + '-home-banner.webp');
      root.style.setProperty('--wsnz-result-background', 'url("' + assetUrl(backgroundFile) + '")');
      root.dataset.resultKingdom = id;
      show('result');
      play('achievement');
    }

    function startFresh() {
      state.index = 0;
      state.answers = [];
      state.scores = createScores();
      state.tied = [];
      state.finalKingdom = null;
      state.tieBreakerUsed = false;
      renderQuestion();
    }

    root.addEventListener('click', function (event) {
      var action = event.target.closest('[data-action]');
      if (!action) return;
      switch (action.dataset.action) {
        case 'start':
          play('button');
          startFresh();
          break;
        case 'back':
          play('button');
          if (state.index > 0) {
            state.index -= 1;
            state.answers = state.answers.slice(0, state.index);
            renderQuestion();
          }
          break;
        case 'retake':
          play('button');
          reset();
          startFresh();
          break;
        case 'save':
          play('button');
          var loginUrl = action.getAttribute('href');
          if (loginUrl) {
            try { sessionStorage.setItem('wsnzPendingKingdom', state.finalKingdom || ''); } catch (error) {}
          }
          break;
      }
    });

    var prior = getResult();
    if (prior && prior.kingdom && kingdoms[prior.kingdom]) {
      state.scores = prior.scores || createScores();
      state.finalKingdom = prior.kingdom;
      finish(prior.kingdom, prior.tieBreakerUsed);
    } else {
      show('intro');
      updateProgress();
    }
  }

  function boot() {
    document.querySelectorAll('[data-wsnz-assessment]').forEach(init);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
}());
